import { HttpClient } from '@angular/common/http';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { FileInfo, GalaxyUploaderService, UploadResponse } from '@vendasta/galaxy/uploader';
import { TaskAttachmentService } from '@vendasta/task';
import { Observable, map } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class SubtasksUploaderService extends GalaxyUploaderService {
  private _loading: WritableSignal<boolean> = signal(false);
  public readonly loading$ = toObservable(this._loading);

  constructor(
    private httpClient: HttpClient,
    private taskAttachmentService: TaskAttachmentService,
  ) {
    super(httpClient);
  }

  buildRequest(fileInfo: FileInfo): Observable<UploadResponse> {
    return this.taskAttachmentService
      .uploadFile(fileInfo.file)
      .pipe(map((resp) => ({ data: { url: resp.url } }) as UploadResponse));
  }
}
